import script from "./land.vue?vue&type=script&setup=true&lang=js"
export * from "./land.vue?vue&type=script&setup=true&lang=js"

import "./land.vue?vue&type=style&index=0&id=7a5f08cf&lang=less"

const __exports__ = script;

export default __exports__